import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Suspense } from "react";
import Dashboard from './components/Dashboard';
import SuggestionsPage from './pages/SuggestionsPage';
import FeedbackPage from './pages/FeedbackPage';
import ManageAdmins from './components/ManageAdmins';

import ConfigPage from './components/ConfigPage';
import AdminLogin from './components/AdminLogin';
import Loading from './components/Loading';
import AdminPrivateRoute from './layouts/AdminPrivateRoute';
import SuperAdminLayouts from './layouts/SuperAdminLayout';
import UsersList from './components/UsersList';
import ShortCodesPage from './components/ShortCodesPage';
import DefaultConfig from './components/DefaultConfigForm';
import BotIdsPage from './pages/BotIdsPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import HealthCheck from './components/HealthCheck';

const App = () => {
  const renderWithSuspense = (Component: React.ComponentType) => (
    <Suspense fallback={<Loading />}>
      <Component />
    </Suspense>
  );
    return (
        <Router>
            <Routes>
                <Route path="/"  element={<AdminLogin />} />
                <Route path="/adminlogin"  element={<AdminLogin />} />
                               <Route path="/actuator/health" element={<HealthCheck />} />

                <Route
                    path="/superadmin"
                    element={
                      <AdminPrivateRoute Layout={SuperAdminLayouts} />
                    }
                  >
                      <Route index element={<Dashboard />} />
                      <Route path="users" element={renderWithSuspense(UsersList)} />
                      <Route path="dashboard" element={<Dashboard />} />
                      <Route path="manage-admins" element={renderWithSuspense(ManageAdmins)} />
                      <Route path="users-list" element={renderWithSuspense(UsersList)} />
                      <Route path="config" element={renderWithSuspense(DefaultConfig)} />
                      <Route path="user/config/:id" element={renderWithSuspense(ConfigPage)} />
                      <Route path='short-codes' element={renderWithSuspense(ShortCodesPage)} />
                      <Route path='bot-ids' element={renderWithSuspense(BotIdsPage)} />
                      <Route path="subscriptions" element={renderWithSuspense(SubscriptionsPage) } />
                      <Route path="feedback" element={renderWithSuspense(FeedbackPage)} />
                      <Route path="suggestions" element={renderWithSuspense(SuggestionsPage)} />
                </Route>
               
            </Routes>
        </Router>
    );
};

export default App;